/**
 * Returns the account name as-is for a single account,
 * or `multi` when the name contains multiple comma-separated accounts.
 */
export function getExportAccountLabel(accountName: string): string {
    if (!accountName) return "";
    const accounts = accountName.split(",");
    if (accounts.length <= 1) return accountName;
    return `multi`;
}

/**
 * Builds a standardized export filename:
 * `insight_[reportType]_[accountLabel]_[M-D-YYYY].[format]`
 */
export function buildExportFilename(
    reportType: string,
    accountName: string,
    format: string
): string {
    const d = new Date();
    const dateStr = `${d.getMonth() + 1}-${d.getDate()}-${d.getFullYear()}`;
    const accountLabel = getExportAccountLabel(accountName);
    return `insight_${reportType}_${accountLabel}_${dateStr}.${format}`;
}
